<template>
  <v-flex data-qa="mortgagelistdisplay-flex-upq3wh">
    <v-overlay v-show="loaderEnabled" :opacity="0.5" data-qa="mortgagelistdisplay-overlay-y3n28q">
      <v-progress-circular
        :color="primaryColor"
        :size="70"
        :width="7"
        indeterminate
        class="circular-loader"
       data-qa="mortgagelistdisplay-progress-circular-uus0o"></v-progress-circular>
      <font class="pl-4 text-h6">{{ $t("common.loadingText") }}</font>
    </v-overlay>
    <v-layout wrap class="ml-2 pt-0" data-qa="mortgagelistdisplay-layout-pub13">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient }"
       data-qa="mortgagelistdisplay-flex-6dw6ag">
        <v-container data-qa="mortgagelistdisplay-container-mo14n">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="mortgagelistdisplay-flex-5go3v">
            <v-flex xs12 sm10 md10 lg8 xl7 data-qa="mortgagelistdisplay-flex-d93u5">
              <v-row no-gutters class="pb-2" data-qa="mortgagelistdisplay-row-e2bscn">
                <v-flex xs2 sm1 md1 lg1 xl1 data-qa="mortgagelistdisplay-flex-moetul">
                  <inline-svg
                    class="mt-2"
                    :src="getNavigationIcon()"
                    width="50"
                    height="50"
                    aria-label="Navigation Icon"
                  ></inline-svg>
                </v-flex>
                <v-flex xs10 sm9 md9 lg9 xl9 class="pt-5" data-qa="mortgagelistdisplay-flex-ncba5">
                  <font class="headline font-weight-light white--text pl-2">
                    {{ $t("mortgage.displayAccounts.mortgageAccount") }}
                  </font>
                </v-flex>
              </v-row>
            </v-flex>
            <v-row class="pt-4 pl-4" data-qa="mortgagelistdisplay-row-bbt0ng">
              <v-layout row wrap data-qa="mortgagelistdisplay-layout-zbtxo">
                <v-flex lg12 xl12 class="px-1" data-qa="mortgagelistdisplay-flex-p4219">
                  <v-layout row wrap data-qa="mortgagelistdisplay-layout-1649bq3">
                    <v-flex xs6 sm5 md4 lg3 xl3 class="px-1" data-qa="mortgagelistdisplay-flex-0hnp8i">
                      <font class="subheading-1 font-weight-medium white--text"
                      >{{ $t("homeCards.mortgageNumber") }}
                      </font>
                    </v-flex>
                    <v-flex xs6 sm5 md4 lg3 xl3 class="px-1" data-qa="mortgagelistdisplay-flex-ulmvv9">
                      <font class="subheading font-weight-medium white--text">{{
                        $t("mortgage.displayAccounts.outstandingBalance")
                      }}</font>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap data-qa="mortgagelistdisplay-layout-psc4x6">
                    <v-flex xs4 sm4 md4 lg3 xl3 class="px-1" data-qa="mortgagelistdisplay-flex-84xi8e">
                      <font v-if="mortgageID" class="text-h5 font-weight-bold white--text">
                        {{ mortgageID }}</font
                      >
                    </v-flex>
                    <v-flex xs4 sm4 md4 lg3 xl3 class="px-1" data-qa="mortgagelistdisplay-flex-kc9dca">
                      <font v-if="accDetails && accDetails.outstandingAmount" class="text-h5 font-weight-bold white--text"
                        >{{
                          $formatter.currency.format(
                            accDetails.outstandingAmount, accDetails.outstandingAmtCurrency
                          )
                        }}
                      </font>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex xs12 sm12 md12 lg9 xl9 class="pl-1 mt-4" data-qa="mortgagelistdisplay-flex-tv736b">
      <v-layout class="px-2" wrap data-qa="mortgagelistdisplay-layout-gz2jdl">
      <v-flex
        v-for="(account, i) in mortgageAccounts.accounts"
        :key="account.loanId"
        xs12
        sm12
        md4
        lg4
        xl4
        class="pa-2"
        :data-qa="`mortgagelistdisplay-flex-2j8v4-${i}`"
      >
        <v-card
          elevation="2"
          class="accountCards--cardsHeight"
          :data-qa="`mortgagelistdisplay-card-09l4vk-${i}`">
          <v-container fluid class="pb-1" :data-qa="`mortgagelistdisplay-container-9zgp2q-${i}`">
            <v-layout
              wrap
              class="px-3"
              :data-qa="`mortgagelistdisplay-layout-j1fbq-${i}`">
              <span class="py-2" :data-qa="`mortgagelistdisplay-span-6my2tv-${i}`">
                <font class="overline font-weight-bold">
                  {{ $t('mortgage.displayAccounts.accountNumber') }}
                </font>
                <br :data-qa="`mortgagelistdisplay-br-jhhl2-${i}`"  />
                <font class="subheading font-weight-thin">
                  {{ account.loanId }}
                </font>
              </span>
              <span class="py-2" :data-qa="`mortgagelistdisplay-span-ku206-${i}`">
                <font class="overline font-weight-bold">
                  {{ $t('mortgage.displayAccounts.description') }}
                </font>
                <br :data-qa="`mortgagelistdisplay-br-evuzaj-${i}`"  />
                <font class="subheading font-weight-thin">
                  {{ account.productName }}
                </font>
              </span>
              <span class="py-2" :data-qa="`mortgagelistdisplay-span-vjwszn-${i}`">
                <font class="overline font-weight-bold">
                  {{ $t('mortgage.displayAccounts.maturityDate') }}
                </font>
                <br :data-qa="`mortgagelistdisplay-br-a06olu-${i}`"  />
                <font class="subheading font-weight-thin">
                  {{ $formatter.formatDate(account.maturityDate) }}
                </font>
              </span>
              <span class="py-2" :data-qa="`mortgagelistdisplay-span-fmfmd2-${i}`">
                <font class="overline font-weight-bold">
                  {{ $t('mortgage.displayAccounts.outstandingBalance') }}
                </font>
                <br :data-qa="`mortgagelistdisplay-br-0p8q4-${i}`"  />
                <font class="subheading font-weight-thin">
                  {{ $formatter.currency.format(account.loanOutstandingAmount.amount, account.loanOutstandingAmount.currency) }}
                </font>
              </span>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      </v-layout>
    </v-flex>
  </v-flex>
</template>

<script>
import '@/styles/pages/accounts/mortgageListDisplay.scss'
import commonService from '@/service/commonService.js'
import event from '@/util/event'
import store from '@/core/store'
import preload from '@/util/preload'

export default {
  name: 'mortgageAccountListDisplay',
  data () {
    return {
      loaderEnabled: false,
      mortgageID: '',
      mortgageAccounts: {
        title: this.$t('common.mortgageAgreementLabel'),
        cardLabels: false,
        openNewACCard: false,
        enableShowMore: false,
        accounts: []
      },
      accDetails: {
        myBalance: 0,
        amount: 0,
        series: [],
        outstandingAmount: 0,
        outstandingAmtCurrency: 0
      }
    }
  },
  beforeCreate () {
    if (this.$route.params.reload) {
      location.reload()
    }
  },
  created () {
    if (this.$route.params && this.$route.params.from === 'Dashboard') {
      this.mortgageAccounts.enableShowMore = true
    } else this.mortgageAccounts.enableShowMore = false
    this.mortgageID = this.$route.params.mortgageID
      ? this.$route.params.mortgageID
      : this.$router.push('/home')
    event.$on('set_myMortgageAccounts', () => {
      this.getListOfLoanAccounts()
      this.loaderEnabled = false
    })
    if (this.ifMyAccountsAvailable()) {
      this.getListOfLoanAccounts()
    } else {
      this.loaderEnabled = true
      preload.getListOfLoanAccounts(
        JSON.parse(sessionStorage.getItem('username'))
      )
      this.loaderEnabled = false
    }
  },
  methods: {
    getNavigationIcon () {
      return this.getSvgIconSrc('Loan_Dashboard')
    },
    ifMyAccountsAvailable () {
      return store.getters['userStore/userData'].mortgageAccounts
    },
    async getListOfLoanAccounts () {
      this.loaderEnabled = true
      let response = {}
      if (this.mortgageID) {
        response = await commonService.getMortgageAccountDetails(
          this.mortgageID)
      }
      if (response && response.items) {
        this.setLoanAccounts(response.items)
      }
      this.loaderEnabled = false
    },
    setLoanAccounts (mortgageAccount) {
      if (mortgageAccount) {
        this.mortgageAccounts.accounts = mortgageAccount
        this.accDetails.amount = 0
        this.accDetails.outstandingAmount = 0
        for (const i in mortgageAccount) {
          this.accDetails.amount += mortgageAccount[i].loanAmount.amount
          this.accDetails.outstandingAmount +=
            mortgageAccount[i].loanOutstandingAmount.amount
          this.accDetails.outstandingAmtCurrency = mortgageAccount[i].loanOutstandingAmount.currency
        }
      }
    }
  },
  beforeDestroy () {
    event.$off('set_myMortgageAccounts')
  }
}
</script>
